module.exports = {
	"is_by_homeowner": {
		"required": false,
		"type": "term",
		"value": null
	},
	"repair": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"demolished_in_moscow_programm": {
		"required": false,
		"type": "term",
		"value": null
	},
	"supported_pins": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"include_new_moscow": {
		"required": false,
		"type": "term",
		"value": null
	},
	"realty_user_id": {
		"required": false,
		"type": "term",
		"value": null
	},
	"apartment": {
		"required": false,
		"type": "term",
		"value": null
	},
	"rooms_for_sale": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"special_promo": {
		"required": false,
		"type": "term",
		"value": null
	},
	"company_id": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"wc_type": {
		"required": false,
		"type": "term",
		"value": null
	},
	"lk_offer_statuses": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"from_jk": {
		"required": false,
		"type": "term",
		"value": null
	},
	"saved_search_id": {
		"required": false,
		"type": "term",
		"value": null
	},
	"bs_center": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"description_include": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"balconies": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"windows_type": {
		"required": false,
		"type": "term",
		"value": null
	},
	"sub_agent_ids": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"bbox": {
		"required": false,
		"type": "term",
		"value": null
	},
	"from_mcad_km": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"geo": {
		"required": false,
		"type": "geo",
		"value": null
	},
	"categories": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"new_object_id": {
		"required": false,
		"type": "term",
		"value": null
	},
	"is_price_reduced": {
		"required": false,
		"type": "term",
		"value": null
	},
	"multi_id": {
		"required": false,
		"type": "term",
		"value": null
	},
	"is_manual": {
		"required": false,
		"type": "term",
		"value": null
	},
	"page": {
		"required": false,
		"type": "term",
		"value": null
	},
	"lift_passanger": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"with_newobject": {
		"required": false,
		"type": "term",
		"value": null
	},
	"building_status": {
		"required": false,
		"type": "term",
		"value": null
	},
	"good_ecology": {
		"required": false,
		"type": "term",
		"value": null
	},
	"creation_date": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"living_area": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"year": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"category": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"random_sort": {
		"required": false,
		"type": "term",
		"value": null
	},
	"with_corpuses": {
		"required": false,
		"type": "term",
		"value": null
	},
	"internet": {
		"required": false,
		"type": "term",
		"value": null
	},
	"hand_over": {
		"required": false,
		"type": "term",
		"value": null
	},
	"wc": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"is_room": {
		"required": false,
		"type": "term",
		"value": null
	},
	"only_foot": {
		"required": false,
		"type": "term",
		"value": null
	},
	"studio": {
		"required": false,
		"type": "term",
		"value": null
	},
	"offset": {
		"required": false,
		"type": "term",
		"value": null
	},
	"house_type": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"kitchen": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"from_offrep": {
		"required": false,
		"type": "term",
		"value": null
	},
	"yeargte": {
		"required": false,
		"type": "term",
		"value": null
	},
	"region": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"not_last_floor": {
		"required": false,
		"type": "term",
		"value": null
	},
	"is_basement": {
		"required": false,
		"type": "term",
		"value": null
	},
	"show_inactive": {
		"required": false,
		"type": "term",
		"value": null
	},
	"description_exclude": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"builders_ids": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"publish_period": {
		"required": false,
		"type": "term",
		"value": null
	},
	"realty_sort_type": {
		"required": false,
		"type": "term",
		"value": null
	},
	"developer_sort_type": {
		"required": false,
		"type": "term",
		"value": null
	},
	"is_pik_promo": {
		"required": false,
		"type": "term",
		"value": null
	},
	"foot_min": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"sost_type": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"cl": {
		"required": false,
		"type": "term",
		"value": null
	},
	"wp": {
		"required": false,
		"type": "term",
		"value": null
	},
	"floorn": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"is_semibasement": {
		"required": false,
		"type": "term",
		"value": null
	},
	"quality": {
		"required": false,
		"type": "term",
		"value": false
	},
	"loggia": {
		"required": false,
		"type": "term",
		"value": null
	},
	"has_decoration": {
		"required": false,
		"type": "term",
		"value": null
	},
	"from_developer": {
		"required": false,
		"type": "term",
		"value": null
	},
	"house_year": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"sort": {
		"required": false,
		"type": "term",
		"value": null
	},
	"jk_class_id": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"build_year": {
		"required": false,
		"type": "term",
		"value": null
	},
	"status_id": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"price_sm": {
		"required": false,
		"type": "term",
		"value": null
	},
	"precision": {
		"required": false,
		"type": "term",
		"value": null
	},
	"phone": {
		"required": false,
		"type": "term",
		"value": null
	},
	"add_clusters_sizes": {
		"required": false,
		"type": "term",
		"value": null
	},
	"id_user": {
		"required": false,
		"type": "term",
		"value": null
	},
	"room": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"bs_center_id": {
		"required": false,
		"type": "term",
		"value": null
	},
	"is_special_promo": {
		"required": false,
		"type": "term",
		"value": null
	},
	"limit": {
		"required": false,
		"type": "term",
		"value": null
	},
	"promo_types": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"penthouse": {
		"required": false,
		"type": "term",
		"value": null
	},
	"yearlte": {
		"required": false,
		"type": "term",
		"value": null
	},
	"minbalkon": {
		"required": false,
		"type": "term",
		"value": null
	},
	"jk_house_id": {
		"required": false,
		"type": "term",
		"value": null
	},
	"bs_center_type": {
		"required": false,
		"type": "term",
		"value": null
	},
	"house_material": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"lift_service": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"total_area": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"currency": {
		"required": false,
		"type": "term",
		"value": 2
	},
	"id": {
		"required": false,
		"type": "term",
		"value": null
	},
	"skipids": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"jk_flat_type_id": {
		"required": false,
		"type": "term",
		"value": null
	},
	"floor": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"finish_date": {
		"required": false,
		"type": "term",
		"value": null
	},
	"has_video": {
		"required": false,
		"type": "term",
		"value": null
	},
	"room_area": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"lifts": {
		"required": false,
		"type": "term",
		"value": null
	},
	"enable_autotest_offers": {
		"required": false,
		"type": "term",
		"value": null
	},
	"with_layout": {
		"required": false,
		"type": "term",
		"value": null
	},
	"_type": "flatsale",
	"newbuildings_search": {
		"required": false,
		"type": "term",
		"value": null
	},
	"rent_period_id": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"promo": {
		"required": false,
		"type": "term",
		"value": null
	},
	"only_flat": {
		"required": false,
		"type": "term",
		"value": null
	},
	"price": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"is_first_floor": {
		"required": false,
		"type": "term",
		"value": null
	},
	"with_neighbors": {
		"required": false,
		"type": "term",
		"value": null
	},
	"is_in_hidden_base": {
		"required": false,
		"type": "term",
		"value": null
	},
	"rooms_count": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"parking_type": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"ipoteka": {
		"required": false,
		"type": "term",
		"value": null
	},
	"build_quarter": {
		"required": false,
		"type": "term",
		"value": null
	},
	"engine_version": {
		"required": false,
		"type": "term",
		"value": 2
	},
	"contact": {
		"required": false,
		"type": "term",
		"value": null
	},
	"billing_package_region_id": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"my_offers_search_text": {
		"required": false,
		"type": "term",
		"value": null
	},
	"ceiling_height": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"room_type": {
		"required": false,
		"type": "term",
		"value": null
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./src/serp/autogenerated-default-filters/flatsale.json
// module id = 509
// module chunks = 0